/**
 * @file InputReportExchange.ts
 * @description output/feature report 触发 + input report 事件返回的交互策略。
 * 预留给后续通过 inputreport 主动返回结果的设备协议。
 */

import { DeviceError, DeviceErrorCode } from '../../../errors/DeviceError'
import type { HidChannel, HidReportListener } from '../HidChannel'
import type { CommandExchange, CommandExchangeRequest } from './CommandExchange'

/**
 * input report 响应策略。
 */
export class InputReportExchange implements CommandExchange {
  constructor(private readonly channel: HidChannel) {}

  public async request(request: CommandExchangeRequest): Promise<DataView> {
    const timeout = request.timeout ?? 3000
    const responseReportId = request.responseReportId ?? request.reportId

    return new Promise<DataView>((resolve, reject) => {
      const timer = setTimeout(() => {
        cleanup()
        reject(new DeviceError(DeviceErrorCode.TIMEOUT, `Input report timeout after ${timeout}ms`))
      }, timeout)

      const listener: HidReportListener = (reportId, data) => {
        if (reportId !== responseReportId) return
        if (request.validate && !request.validate(data)) return
        cleanup()
        resolve(data)
      }

      const cleanup = () => {
        clearTimeout(timer)
        this.channel.offInputReport(listener)
      }

      this.channel.onInputReport(listener)
      this.channel.sendOutputReport(request.reportId, request.payload).catch((error) => {
        cleanup()
        reject(error)
      })
    })
  }
}
